'use client';

import Link from 'next/link';
import type { ReactNode } from 'react';

interface NavIconLinkProps {
  href: string;
  label: string;
  children: ReactNode;
}

/**
 * Header nav icon with a fast custom tooltip.
 * Replaces the slow native `title` attribute tooltip.
 */
export default function NavIconLink({ href, label, children }: NavIconLinkProps) {
  return (
    <div className="relative group/nav-icon">
      <Link
        aria-label={label}
        className="cursor-pointer rounded-lg p-2 text-gray-500 transition-colors hover:bg-purple-50 focus:outline-none focus:ring-0 dark:text-gray-400 dark:hover:bg-purple-900/30 flex items-center justify-center"
        href={href}
      >
        <span className="sr-only">{label}</span>
        {children}
      </Link>
      {/* Custom tooltip — appears in 80 ms, no native-title delay */}
      <span
        aria-hidden
        className="pointer-events-none absolute top-full left-1/2 mt-1.5 -translate-x-1/2 whitespace-nowrap rounded-md bg-gray-900 px-2 py-1 text-xs font-medium text-white opacity-0 transition-opacity duration-75 delay-[80ms] group-hover/nav-icon:opacity-100 dark:bg-gray-700 z-50"
      >
        {label}
      </span>
    </div>
  );
}
